import React from "react";

const RootCause = ({ rootCauses }) => {
  // Pick the first root cause (since only one exists per incident now)
  const rootCause = rootCauses && rootCauses.length > 0 ? rootCauses[0] : null;
  const summary = rootCause?.summary || "";

  return (
    <div className="final-report-content mb-3">
      <h2 className="font-18 font-weight-bold heading-color mb-2">
        Root Cause Analysis:
      </h2>
      {summary ? (
        <p
          className="font-13 font-weight-normal text-color"
          dangerouslySetInnerHTML={{
            __html: summary.replace(/\n/g, "<br/>"),
          }}
        />
      ) : (
        <p className="font-13 font-weight-normal text-color">
          No root cause summary available
        </p>
      )}
    </div>
  );
};

export default RootCause;
